import BaseViewExtensionViewFactory from '@/Factories/ViewFactories/BaseViewExtensionViewFactory';
import ComponentManager from '@/Management/ComponentManager';
import NavigationService from '@/Management/NavigationService';
import RADApplication from '@/Management/RADApplication';
export default class ViewExtensionViewFactory extends BaseViewExtensionViewFactory {
    constructor(params: any) {
        super($.extend({
            viewElementName: 'ViewExtension',
            viewModelName: 'ViewExtensionViewModel',
            viewName: 'ViewExtensionView'
        }, params));
    }
}

ComponentManager.setFactory('ViewExtension', ViewExtensionViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');